<template>
  <div>
    <item
      v-for="p in distinctPaths"
      :key="p"
      :items="getPanelsByThematicPath(p)"
      :name="p"
      :isToday="isToday"
      :now="now"
      @selectedItem="e => $emit('selectedItem', e)"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/util/axios";
import Item from "./ThematicPathCollapse.vue";

export default {
  components: { Item },
  props: ["items"],
  data() {
    return {
      now: new Date()
    };
  },
  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current"
    }),
    isToday() {
      if (!this.items || !this.items.length) return false;
      const first = this.items.find(i => i.startDate);
      if (!first) return false;
      const itemDate = new Date(first.startDate);
      return (
        this.now.getFullYear() === itemDate.getFullYear() &&
        this.now.getMonth() === itemDate.getMonth() &&
        this.now.getDate() === itemDate.getDate()
      );
    },
    distinctPaths: function() {
      let paths = [
        ...new Map(
          this.items.map(item => [
            item.description.thematicPath,
            item.description.thematicPath
          ])
        ).values()
      ];

      return paths.sort((a, b) => (a > b ? 1 : -1));
    }
  },
  methods: {
    getPanelsByThematicPath(value) {
      return this.items
        .filter(e => e.description.thematicPath === value)
        .sort((a, b) =>
          b.startDate < a.startDate ||
          (a.startDate == b.startDate && b.endDate < a.endDate)
            ? 1
            : -1
        );
    }
  },
  mounted() {
    this._nowTimer = setInterval(() => { this.now = new Date(); }, 60000);
  },
  beforeDestroy() {
    clearInterval(this._nowTimer);
  }
};
</script>
<style lang="scss" scoped>
.info {
  .icon > i {
    font-size: 2.5rem !important;
  }
  .info-title {
    margin: 1rem;
  }
}
</style>